export const MethodButton = (props: { label: React.ReactNode; icon: React.ReactNode; onClick: () => void; trailingLabel?: React.ReactNode }) => {
    return (
        <button
            onClick={props.onClick}
            className='bg-always-white outline-border-default inline-flex items-center justify-between gap-3 self-stretch rounded-xl p-4 outline-1 outline-offset-[-1px]'>
            <div className='inline-flex min-w-0 items-center justify-start gap-3'>
                {props.icon}
                <div className='text-always-black text-base font-medium'>{props.label}</div>
            </div>
            {props.trailingLabel ? (
                <div className='text-always-black border-border-default shrink-0 rounded-lg border border-solid px-2.5 py-1 text-sm font-medium'>
                    {props.trailingLabel}
                </div>
            ) : null}
        </button>
    );
};
